import { FC, ReactNode, useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';
import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';
import { getSupportToken } from '@/lib/services/auth.service';
import useApp from '@/hooks/use-app.hook';

interface Props {
  children: ReactNode;
}
const IntercomUpdater: FC<Props> = ({ children }) => {
  const { signedIn, user } = useApp();
  const { update } = useIntercom();
  const { spUserId } = user || { spUserId: '' };

  const { data: supportToken } = useQuery(
    [QueryKey.SupportToken, spUserId],
    async () => getSupportToken(),
    { enabled: signedIn }
  );

  useEffect(() => {
    if (supportToken && spUserId) {
      update({
        userId: spUserId,
        intercomUserJwt: supportToken.jwt,
      });
    }
  }, [update, supportToken, spUserId]);

  return <>{children}</>;
};

export default IntercomUpdater;
